import {  useEffect, useState } from 'react';
import { Banner, Footer, Navbar } from '../components';
import {Typography } from '@material-tailwind/react';

export function Submission() {
  const [navbarTransparent, setNavbarTransparent] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Set navbar to not transparent if the scroll position is more than 100px
      const shouldNavbarBeTransparent = window.scrollY < 100;
      setNavbarTransparent(shouldNavbarBeTransparent);
    };

    // Add event listener for scroll
    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className="w-full relative">
        <Navbar transparent={navbarTransparent} />
        <Banner title={"Submission"} />

        <section className="w-full container mx-auto py-12 px-14" >

          <div className="flex flex-col justify-center  w-full h-full p-8">
            <Typography variant="h3" color="blue-gray" className="mb-2">
            Submission
            </Typography>
            <Typography color="gray" className="font-normal mt-2">
            The papers should be submitted via <a href="#" className="text-primary-500 underline" > EasyChair</a>. The submission is done in four steps: set up an account with 
            EasyChair, enter a paper title and abstract, and finally upload your paper. Please be sure to read the formatting instructions. 
            Some common questions about submission can be sent via the contact email. Submitted papers should be prepared according to the published specification for formatting and style.
            </Typography>

            <Typography variant="h3" color="blue-gray" className="mb-2 mt-8">
              Abstract
            </Typography>
            <Typography color="gray" className="font-normal mt-2">
              This talk will present some of the development in multi-objective approaches for solving complex scheduling problem.
              The first part of the talk will investigate multi-objective and weighted single objective approaches to a real world workforce scheduling problem. The computational experiments show that multi-objective genetic algorithms can create solutions whose fitness is close to that of the solution created by the genetic algorithms using weighted sum objectives even though the multi-objective approaches know nothing of the weights. In second part of the talk will discuss the variable fitness function approach to enhance the metaheuristic approaches by evolving weights for each of the multiple objectives. The results show that the variable fitness function approach improves the performance of constructive and variable neighbourhood search approaches on workforce scheduling problem instances.
            </Typography>

            <Typography variant="h3" color="blue-gray" className="mb-2 mt-8">
              Biography
            </Typography>
            <Typography color="gray" className="font-normal mt-2">
              This talk will present some of the development in multi-objective approaches for solving complex scheduling problem.
              The first part of the talk will investigate multi-objective and weighted single objective approaches to a real world workforce scheduling problem. The computational experiments show that multi-objective genetic algorithms can create solutions whose fitness is close to that of the solution created by the genetic algorithms using weighted sum objectives even though the multi-objective approaches know nothing of the weights. In second part of the talk will discuss the variable fitness function approach to enhance the metaheuristic approaches by evolving weights for each of the multiple objectives. The results show that the variable fitness function approach improves the performance of constructive and variable neighbourhood search approaches on workforce scheduling problem instances.
            </Typography>
          </div>

        </section>
        <Footer />

      </div>
    </>
  );
}
